<template>
  <b-tab :title="$store.state.localization.data.mainPage.fuelTanksLabel" active>
    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.userSettings.displayedColumnsLabel"
      label-for="input-horizontal"
    >
    </b-form-group>

    <b-form-select
      v-model="displayedColumns.data"
      :options="displayedColumns.values"
      multiple
      :select-size="13"
      style="font-size: 13px"
    ></b-form-select>
    <hr />
    <b-form-checkbox v-model="hideSummary" switch>
      {{ $store.state.localization.data.mainPage.userSettings.fuelTanksTab.hideSummaryLabel }}
    </b-form-checkbox>
    <hr />
    <b-form-group
      label-cols-sm="8"
      label-cols-lg="6"
      content-cols-sm
      content-cols-lg="4"
      :label="$store.state.localization.data.mainPage.userSettings.fuelTanksTab.fuelVolumePrecisionLabel"
      label-for="input-horizontal"
    >
      <b-form-input
        type="number"
        min="1"
        max="3"
        v-model="fuelVolumePrecision"
        style="font-size: 13px"
      ></b-form-input>
    </b-form-group>
  </b-tab>
</template>

<script>
import { userService } from "../../../services";

export default {
  name: "FuelTanksTab",
  data() {
    return {
      displayedColumns: {
        data: [],
        values: [],
      },
      hideSummary: false,
      fuelVolumePrecision: userService.FUEL_VOLUME_PRECISION_DEFAULT
    };
  },
  created() {
    for (const key of Object.keys(
      this.$store.state.localization.data.mainPage.fuelTanks.tableColumns
    )) {
      this.displayedColumns.values.push({
        value: key,
        text: this.$store.state.localization.data.mainPage.fuelTanks
          .tableColumns[key],
      });
    }

    const displayedColumnsSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.FUEL_TANKS_TABLE_DISPLAYED_COLUMNS;
      });

    if (displayedColumnsSetting) {
      const displayedColumns = displayedColumnsSetting.settingValue.split(",");

      if (displayedColumns) {
        for (let i = 0; i < displayedColumns.length; i++) {
          this.displayedColumns.data.push(displayedColumns[i]);
        }
      }
    } else {
      for (const key of Object.keys(
        this.$store.state.localization.data.mainPage.fuelTanks.tableColumns
      )) {
        this.displayedColumns.data.push(key);
      }
    }

    const hideSummarySetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.FUEL_TANKS_TABLE_HIDE_SUMMARY;
      });

      if (hideSummarySetting && hideSummarySetting.settingValue == "true") {
        this.hideSummary = true;
      }

    const fuelVolumePrecisionSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.FUEL_VOLUME_PRECISION;
      });

      if (fuelVolumePrecisionSetting) {
        this.fuelVolumePrecision = parseInt(fuelVolumePrecisionSetting.settingValue );
      } else {
        this.fuelVolumePrecision = userService.FUEL_VOLUME_PRECISION_DEFAULT;
      }
  },
  methods: {
    getDisplayedColumns() {
      return this.displayedColumns.data;
    },
    getHideSummary() {
      return this.hideSummary;
    },
    getFuelVolumePrecision() {
      return this.fuelVolumePrecision;
    },
  },
};
</script>
